import{NotificationContext as t}from"../NotificationProvider.js";import{useContext as o}from"react";var i=()=>{const{push:i}=o(t);return{push:i}};export{i as useNotifications};
//# sourceMappingURL=useNotifications.js.map